// Import: Middleware Action & Custom Types
import { CLEAN_IFT_REPORT, CLEAN_IFT_REPORT_ERROR } from '_models/redux/types';

// Action function
export const cleanIftReportAction = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_IFT_REPORT,
    });
  } catch {
    dispatch({
      payload: undefined,
      type: CLEAN_IFT_REPORT_ERROR,
    });
  }
};
